import { Box, Typography, Link, Grid } from '@mui/material';
import { LinkedIn, Twitter, Email } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box sx={{ 
      backgroundColor: '#333',
      color: 'white',
      py: 6,
      px: 4,
      mt: 'auto'
    }}>
      <Grid container spacing={4} justifyContent="space-between">
        <Grid item xs={12} md={4}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
            Aquamire
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Investing in the architects of private markets through GP stakes investments.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Link href="#" color="inherit">
              <LinkedIn />
            </Link>
            <Link href="#" color="inherit">
              <Twitter />
            </Link>
            <Link href="#" color="inherit">
              <Email />
            </Link>
          </Box>
        </Grid>

        <Grid item xs={6} md={2}>
          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Navigation
          </Typography>
          <Link href="/" color="inherit" underline="hover" display="block" sx={{ mb: 1 }}>Home</Link>
          <Link href="/about" color="inherit" underline="hover" display="block" sx={{ mb: 1 }}>About</Link>
          <Link href="/strategy" color="inherit" underline="hover" display="block" sx={{ mb: 1 }}>Strategy</Link>
          <Link href="/investments" color="inherit" underline="hover" display="block">Investments</Link>
        </Grid>

        <Grid item xs={6} md={2}>
          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Legal
          </Typography>
          <Link href="#" color="inherit" underline="hover" display="block" sx={{ mb: 1 }}>Privacy Policy</Link>
          <Link href="#" color="inherit" underline="hover" display="block" sx={{ mb: 1 }}>Terms of Use</Link>
          <Link href="#" color="inherit" underline="hover" display="block">Disclosures</Link>
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Contact Us
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            123 Investment Avenue<br />
            New York, NY 10001
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            info@aquamire.com<br />
            +1 (555) 123-4567
          </Typography>
        </Grid>
      </Grid>

      <Box sx={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', mt: 4, pt: 3 }}>
        <Typography variant="body2" align="center">
          © {new Date().getFullYear()} Aquamire. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
